import React from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { ConfigProvider, Layout, Menu } from 'antd';
import {
  DashboardOutlined,
  BarChartOutlined,
  SettingOutlined,
  NotificationOutlined,
  MonitorOutlined,
  DatabaseOutlined,
  ExperimentOutlined,
  KeyOutlined,
} from '@ant-design/icons';

const { Sider, Content } = Layout;

const menuItems = [
  { key: '/admin', icon: <DashboardOutlined />, label: 'Dashboard / Tenants' },
  { key: '/admin/revenue', icon: <BarChartOutlined />, label: 'Revenue' },
  { key: '/admin/plans', icon: <SettingOutlined />, label: 'Plans' },
  { key: '/admin/invite-codes', icon: <KeyOutlined />, label: 'Invite Codes' },
  { key: '/admin/announcements', icon: <NotificationOutlined />, label: 'Announcements' },
  { key: '/admin/system', icon: <MonitorOutlined />, label: 'System' },
  { key: '/admin/data-audit', icon: <DatabaseOutlined />, label: 'Data Audit' },
  { key: '/admin/scenario-tests', icon: <ExperimentOutlined />, label: 'Tests' },
];

const AdminLayout: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Map /admin to dashboard, /admin/tenants to dashboard too (same page)
  const selectedKey = location.pathname === '/admin' ? '/admin' : location.pathname;

  // Hide sidebar on the MFA setup wall — admin has no MFA yet so all other
  // admin pages are gated by the backend; showing nav links would just bounce
  // them back here.
  const fullScreen = location.pathname === '/admin/mfa-setup';

  if (fullScreen) {
    return (
      <ConfigProvider modal={{ mask: { blur: false } }}>
        <Layout style={{ minHeight: '100vh', background: '#f0f2f5' }}>
          <Content><Outlet /></Content>
        </Layout>
      </ConfigProvider>
    );
  }

  return (
    <ConfigProvider modal={{ mask: { blur: false } }}>
    <Layout style={{ minHeight: '100vh' }}>
      <Sider
        width={220}
        theme="light"
        style={{
          borderRight: '1px solid #f0f0f0',
          position: 'fixed',
          left: 0,
          top: 0,
          bottom: 0,
          zIndex: 10,
        }}
      >
        <div style={{ padding: '16px 24px', borderBottom: '1px solid #f0f0f0' }}>
          <h2 style={{ fontSize: 16, fontWeight: 700, color: '#1976D2', margin: 0 }}>Admin Panel</h2>
        </div>
        <Menu
          mode="inline"
          selectedKeys={[selectedKey]}
          items={menuItems}
          style={{ borderRight: 0 }}
          onClick={({ key }) => navigate(key)}
        />
      </Sider>
      <Layout style={{ marginLeft: 220, background: '#f0f2f5' }}>
        <Content style={{ padding: 24, minHeight: '100vh' }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
    </ConfigProvider>
  );
};

export default AdminLayout;
